import config from '@/Constants';
import { Favorite } from '@/modules/shared/domain/interfaces';
import { AxiosHelper } from '@/modules/shared/infra/protocols/http';
import snakeToCamel from '@/utils/snakeToCamel';
import { useMutation, useQueryClient } from 'react-query';
import { favoritesKey } from './useFavoritesQuery';

interface CreateFavoriteParams {
  name: string;
  favorite_type: string;
  platform: string;
  values: any;
  access_settings?: {
    users: string[];
    teams: string[];
  };
}

const createFavorite = async (params: CreateFavoriteParams): Promise<Favorite> => {
  const response = await AxiosHelper.post({
    url: config.FAVORITES_URL,
    body: params,
    apiV: 1,
  });

  if (response.statusCode < 200 || response.statusCode > 300) {
    throw new Error('Error creating favorite');
  }

  return snakeToCamel(response.body);
};

export function useCreateFavoriteMutation() {
  const queryClient = useQueryClient();

  return useMutation(createFavorite, {
    onSuccess: () => {
      queryClient.invalidateQueries(favoritesKey);
    },
  });
}
